<template>
  <div>
    <productPricing />
    <contact />
    <roadMap />
  </div>
</template>

<script>
import contact from "../ContactSection";
import productPricing from "./components/ProductPricing";
import roadMap from "../DownloadSection.vue";

export default {
  components: {
    contact,
    productPricing,
    roadMap,
  },
};
</script>

<style></style>
